$(document).ready(function(){


    /*
     * Collections Add / delete items
     */

    /*if ($(".custom-collection-row").length) {

        function addItem(addButton) {
            var containerSelector = addButton.dataset.container;
            var container = document.querySelector(containerSelector);
            var prototype = container.dataset.prototype;

            var index = container.querySelectorAll('.custom-collection-row-entry').length;

            var newItem = prototype.replace(/__name__/g, index);

            // Create a wrapper element for the new item
            var itemWrapper = document.createElement('div');
            itemWrapper.classList.add('custom-collection-row-entry');
            itemWrapper.innerHTML = newItem;

            container.appendChild(itemWrapper);

            var addItemButtons = itemWrapper.getElementsByClassName('add-item');
            for (var i = 0; i < addItemButtons.length; i++) {
                addItemButtons[i].addEventListener('click', function() {
                    addItem(this);
                });
            }


            var deleteButtons = container.querySelectorAll('.delete-button');
            var newDeleteButton = deleteButtons[deleteButtons.length - 1];
            newDeleteButton.addEventListener('click', function() {
                deleteItem(this);
            });
        }

        function deleteItem(deleteButton) {

            var item = deleteButton.parentNode.closest('.custom-collection-row-entry');
            item.parentNode.removeChild(item);
        }

        var addButtons = document.getElementsByClassName('add-item');
        for (var i = 0; i < addButtons.length; i++) {
            addButtons[i].addEventListener('click', function() {
                addItem(this);
            });
        }

        var deleteButtons = document.getElementsByClassName('delete-button');
        for (var i = 0; i < deleteButtons.length; i++) {
            deleteButtons[i].addEventListener('click', function() {
                deleteItem(this);
            });
        }
    }*/

    /*if ($('.white-popup-auto-close').length) {
        $('.white-popup-auto-close').each(function(i, obj) {
            setTimeout(function(){
                $(obj).addClass('is-hidden');
                $(obj).remove();
            }, 3000);
        });
    }*/

    if ($('.notification-auto-close').length) {
        $('.notification-auto-close .delete').on('click', function(){
            $(this).closest('.notification-auto-close').addClass('is-hidden');
            $(this).closest('.notification-auto-close').remove();
        });
        $('.notification-auto-close').each(function(i, obj) {
            setTimeout(function(){
                $(obj).addClass('is-hidden');
                $(obj).remove();
            }, 3000);
        });
    }


    if ($('#solicitude_step2_form_project_keywords').length && $('#solicitude_step2_form_project_keywordComment').length) {
        let checked = false;
        $('#solicitude_step2_form_project_keywords input[data-comment="1"]').each(function(){
            if ($(this).is(':checked')) {
                checked = true;
            }
        });
        $('#solicitude_step2_form_project_keywordComment').closest('div.column').toggle(checked);
        $('#solicitude_step2_form_project_keywords input[data-comment="1"]').on('change', function(){
            let checked = false;
            $('#solicitude_step2_form_project_keywords input[data-comment="1"]').each(function(){
                if ($(this).is(':checked')) {
                    checked = true;
                }
            });
            $('#solicitude_step2_form_project_keywordComment').closest('div.column').toggle(checked);
        });
    }
    
    if ($('#project_update_funding_period_form_durationApproved').length
        && $('#project_update_funding_period_form_fundingStart').length
        && $('#project_update_funding_period_form_fundingEnd').length
    ) {
		function updateFundingPeriodEnd()
		{
			const durationMonth = parseInt($('#project_update_funding_period_form_durationApproved').val(), 10);
			const startDate = $('#project_update_funding_period_form_fundingStart').val();
			if (durationMonth != '' && startDate !='' ) {
				let date = new Date(startDate);
				date.setMonth(date.getMonth()+durationMonth);
				date.setDate(date.getDate()-1);
				$('#project_update_funding_period_form_fundingEnd').val(date.toISOString().substring(0,10));
			}
		}
		$('#project_update_funding_period_form_durationApproved').on('change', updateFundingPeriodEnd);
		$('#project_update_funding_period_form_fundingStart').on('change', updateFundingPeriodEnd);
	}

	if($(".table-approved-funding").length) {
		$('.table-approved-funding input[data-personal-year]').on('change', function(){
			
			var totalYear = 0;
			$('.table-approved-funding input[data-personal-year='+$(this).attr('data-personal-year')+']').each( function(){
				totalYear += parseFloat($(this).val());
			});
			$('.table-approved-funding th[data-personal-year='+$(this).attr('data-personal-year')+']').html(Number(totalYear).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
			
			var totalRow = 0;
			$(this).closest('tr').find('input[data-personal-year]').each( function(){
				totalRow += parseFloat($(this).val());
			});
			$(this).closest('tr').find('input[data-personal-row-total]').val(totalRow.toFixed(2));
			
			var total = 0;
			$('.table-approved-funding input[data-personal-row-total]').each( function(){
				total += parseFloat($(this).val());
			});
			$('.table-approved-funding th[data-personal-row-total]').html(Number(total).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));			
		});
		
		$('.table-approved-funding input[data-year]').on('change', function(){
			var section = $(this).attr('data-type');
			var total = 0;
			$('.table-approved-funding input[data-type='+section+']').each( function(){
				total += parseFloat($(this).val());
			});
			$('.table-approved-funding tr[data-type='+section+'] th[data-type=total]').html(Number(total).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
		});
	}
	
	
    // formulari Scientific Report Form amb camps depenents
    var enableFieldFunc = function (origin) {
        var originJQuery = $(origin);

        var destinationSelector = originJQuery.attr('data-enable-field');
        var $selectedItems = $(destinationSelector);
        $selectedItems.each(function() {
            $(this).hide();
        });
        
        var originValue = originJQuery.val();
        var $enabledItems = $(destinationSelector + '[data-state="' + originValue+ '"]');
        $enabledItems.each(function() {
            $(this).show();
        });
    }

    var $dataEnableField = $('[data-enable-field]');

    $dataEnableField.each(function () {
        var that = this;
        enableFieldFunc(that);
    });

    $dataEnableField.change(function(e) {
        enableFieldFunc(e.target);
    });	
});

document.addEventListener('DOMContentLoaded', () => {
  (document.querySelectorAll('.notification .delete') || []).forEach(($delete) => {
    const $notification = $delete.parentNode.parentNode;

    $delete.addEventListener('click', () => {
      $notification.parentNode.removeChild($notification);
    });
  });
});